"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var paginationHelper_1 = require("./paginationHelper");
function areAllPageItemsSelected(props, state) {
    var data = props.data, selection = props.selection, lazy = props.lazy;
    var filterValue = state.filterValue, sortField = state.sortField, sortOrder = state.sortOrder, activePage = state.activePage, itemsPerPage = state.itemsPerPage, paginate = state.paginate, visibleFields = state.visibleFields;
    var isSelectAllChecked = false;
    var currentPageItems = paginate && !lazy ? paginationHelper_1.getPageEntries(data, activePage, itemsPerPage, visibleFields, sortOrder, sortField, filterValue) : data;
    if (selection) {
        if (selection.length < currentPageItems.length) {
            isSelectAllChecked = false;
        }
        else {
            isSelectAllChecked = currentPageItems.every(function (currentPageItem) { return selection.includes(currentPageItem); });
        }
    }
    return isSelectAllChecked;
}
exports.areAllPageItemsSelected = areAllPageItemsSelected;
//# sourceMappingURL=selectionHelpers.js.map